// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__s4N3W","loader__image":"Loader_loader__image__4QV48"};